import React from 'react';
import styled, { css } from 'styled-components';

import { placeholderAnimationCss } from '@tager/web-components';

import { media } from '@/utils/mixin';

function MobileNavigationPlaceholder() {
  return (
    <Component>
      <CloseButton></CloseButton>
      <ShareButton></ShareButton>
    </Component>
  );
}

export default MobileNavigationPlaceholder;

const Component = styled.div`
  display: none;

  ${media.tablet(css`
    display: flex;
    margin-bottom: 12px;
    justify-content: space-between;
  `)}
`;

const CloseButton = styled.div`
  width: 70px;
  height: 24px;
  border-radius: 8px;
  ${placeholderAnimationCss}
`;

const ShareButton = styled.div`
  height: 24px;
  width: 24px;
  border-radius: 50%;
  ${placeholderAnimationCss}
`;
